import { Select, SelectTrigger } from "@tellescope/ui";
import { Globe } from "lucide-react";
import { TimezoneSelectContent } from "./TimezoneSelectContent";
import { getTimezoneName } from "../../utils";
import { useTranslation } from "react-i18next";

export interface TimezoneSelectorProps {
  value: string;
  onChange: (value: string) => void;
}

export const TimezoneSelector = ({ value, onChange }: TimezoneSelectorProps) => {
  const { i18n } = useTranslation("calendar");

  const longGenericValue = getTimezoneName(value, "longGeneric", i18n.language);
  const valueIsAbbreviated =
    longGenericValue.split(" ").length === 1 && longGenericValue.toUpperCase() === longGenericValue;
  const valueToDisplay = valueIsAbbreviated
    ? longGenericValue
    : longGenericValue
        .split(" ")
        .map((word) => word.charAt(0))
        .join("");

  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger data-testid="calendar-timezone-trigger">
        <Globe />
        {valueToDisplay}
      </SelectTrigger>
      <TimezoneSelectContent />
    </Select>
  );
};
